import React, {Component} from 'react';
import {connect} from 'formik';
import get from 'lodash/get';
import LogicOpButton from './LogicOpButton';
import * as constants from '../../../constants';

class LogicOp extends Component {
    constructor(props) {
        super(props);
        this.clickAnd = this.clickAnd.bind(this);
        this.clickOr = this.clickOr.bind(this);
    }

    componentDidMount() {
        this.props.formik.registerField(this.props.id, this);
    }

    componentWillUnmount() {
        this.props.formik.unregisterField(this.props.id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.id !== prevProps.id) {
            this.props.formik.unregisterField(prevProps.id);
            this.props.formik.registerField(this.props.id, this);
        }
    }

    setLogicOp(logicOp) {
        const {formik, id} = this.props;
        formik.setFieldValue(id, logicOp);
    }

    clickAnd(e) {
        this.setLogicOp(constants.LOGIC_OP_AND);
    }

    clickOr(e) {
        this.setLogicOp(constants.LOGIC_OP_OR);
    }

    render() {
        const {formik, name} = this.props;
        const logicOp = get(formik.values, name);

        return (
            <>
                <LogicOpButton className="mr-2" label="And" active={logicOp === constants.LOGIC_OP_AND} onClick={this.clickAnd} />
                <LogicOpButton label="Or" active={logicOp === constants.LOGIC_OP_OR} onClick={this.clickOr} />
            </>
        );
    }
}

export default connect(LogicOp);
